<template>
    <div class="query-history">
        <b-card no-body bg-variant="light" header-tag="header">
            <template v-slot:header>
                <h6 class="mb-0">Son 10 Sorgu <v-icon name="history" class="float-right"/></h6>
            </template>
            <b-list-group flush>
                <b-list-group-item v-for="item in data" :key="item.from+item.query">                
                    <h6 class="mb-0">
                        <a href="#" @click="reQuery(item)" class="historyItem">
                            <v-icon :name="item.icon" />
                            {{ item.query }}
                        </a> 
                        <a href="#" @click="remove(item)" class="float-right historyItemDelete"><v-icon name="trash-alt"/></a>
                    </h6>
                </b-list-group-item>
                <b-list-group-item v-if="data.length < 1">                
                    <h6 class="mb-0">
                        <a href="#" class="historyItem">
                            <v-icon name="info-circle" />
                            Sorgu kaydı yok.
                        </a> 
                    </h6>
                </b-list-group-item>


            </b-list-group>
        </b-card>
    </div>
</template>

<script>
export default {
    name: 'QueryHistory',
    props: {
        data: Array
    },
    methods: {
        remove(item) {
            this.$emit('RemoveHistoryItem', item);
        },
        reQuery(item) {
            this.$emit('ReQueryHistoryItem', item);
        }
    }
}
</script>

<style scoped>

</style>